import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const pomgroupApi = api
  .enhanceEndpoints({ addTagTypes: ['POMGroup'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOMGroups: builder.query<po_mgroup[], any>({
        query: ({ cid, olid }) => `pomgroup/${cid}/${olid}`,
        providesTags: ['POMGroup']
      }),
      getPOMGroupById: builder.query<po_mgroup, string>({
        query: id => `pomgroup/byid/${id}`,
        providesTags: ['POMGroup']
      }),
      importPOMGroup: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `pomgroup/import`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['POMGroup']
      }),
      insertPOMGroup: builder.mutation({
        query: pomgroup => ({
          url: `pomgroup/`,
          method: 'POST',
          body: pomgroup
        }),
        invalidatesTags: ['POMGroup']
      }),
      updatePOMGroup: builder.mutation({
        query: pomgroup => ({
          url: `pomgroup/`,
          method: 'PUT',
          body: pomgroup
        }),
        invalidatesTags: ['POMGroup']
      }),
      deletePOMGroup: builder.mutation({
        query: pomgroup => ({
          url: `pomgroup/${pomgroup.gr_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POMGroup']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOMGroupsQuery,
  useGetPOMGroupByIdQuery,
  useImportPOMGroupMutation,
  useInsertPOMGroupMutation,
  useUpdatePOMGroupMutation,
  useDeletePOMGroupMutation
} = pomgroupApi;

